// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 14 ? "bh-helper-instance" : chunkId) + "-legacy." + {"14":"c15aff00","119":"4e58f453","275":"3b465eeb","496":"e79ed9ac","530":"b6ea9706","669":"caf7cfb3","751":"d9ad6e15"}[chunkId] + ".js";
};